import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify';
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import wysiwyg from "vue-wysiwyg";
import 'vue-wysiwyg/dist/vueWysiwyg.css'
import './styles/styles.scss'

import '@devinspire/survey-builder/dist/survey-builder.css'

// LIBS
import serviceCaller from "@/libs/http/service-caller"

//COMPONENTS
import confirmationDialog from "@/components/common/confirmation-dialog.vue";
import organogramNode from "@/components/Organogram/organogram-node.vue";
import './plugins/controller-helper.js'
import './plugins/auth.js'
import './components/global-components.js'


Vue.use(wysiwyg, {});
Vue.use(serviceCaller);

Vue.component("confirmation-dialog", confirmationDialog);
Vue.component("organogram-node", organogramNode);

Vue.config.productionTip = false

Vue.mixin({
  data: function () {
    return {
      get serverAddress() {
        return process.env.VUE_APP_API;
      }
    }
  },
  computed: {
    systemModules() {
      return window._SystemModules;
    }
  }
  // created() {
  //   this.$loading = false;
  // }
});

new Vue({
  router,
  store,
  vuetify,
  render: function (h) { return h(App) }
}).$mount('#app')
